import { nanoid } from "nanoid";

// constants
export const EDITOR_ID = `editor_${nanoid()}`;

export const EMAIL_CONFIG = {
  TO: "to",
  CC: "cc",
  BCC: "bcc",
}